import { PlatformId } from "@/types/platform.types";

/**
 * Whether an organization (federation) is attached to a platform — i.e. the
 * `(platform, organization)` scope pair is a real `organization_platform`
 * attachment. Drives the pair-attachment guard in `CurrentOrganizationProvider`:
 * a scoped URL pairing an org with a platform it does not operate on must not
 * render an editable org context (R3).
 *
 * Fail-open rule: an **empty** `attachedPlatformIds` list means "unknown" — a
 * BE that has not shipped the field yet (deploy gap) maps to `[]`, and a real
 * federation is always attached to at least one platform (detaching the last
 * platform is blocked server-side). Blocking on empty would Forbidden every
 * scoped URL during the deploy gap, so empty passes.
 */
export const isOrganizationAttachedToPlatform = (
  attachedPlatformIds: readonly PlatformId[],
  platformId: PlatformId
): boolean => {
  if (attachedPlatformIds.length === 0) {
    return true;
  }
  return attachedPlatformIds.includes(platformId);
};
